import get from 'lodash/get'
import {
  fetchCollection
} from './index'

import { inspectorSchema } from '../schemas'

export const INSPECTORS_REQUEST = 'INSPECTORS_REQUEST'
export const INSPECTORS_SUCCESS = 'INSPECTORS_SUCCESS'
export const INSPECTORS_FAILURE = 'INSPECTORS_FAILURE'

function fetchInspectorsForLocation (locationId, url, reload) {
  return fetchCollection({
    url,
    key: 'inspectors',
    schema: inspectorSchema,
    actions: [ INSPECTORS_REQUEST, INSPECTORS_SUCCESS, INSPECTORS_FAILURE ],
    responseInterceptor: (response) => ({ ...response, locationId, reload })
  })
}

export function loadInspectorsForLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.inspectorsByLocation.${locationId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/inspectors`
    }

    return dispatch(fetchInspectorsForLocation(locationId, nextPageUrl, !nextPage))
  }
}




// WEBPACK FOOTER //
// ./src/actions/inspectors.js